module.exports = __webpack_public_path__ + "media/src/images/apple-icon-114x114-0cf5c629ee41eb4ee810389d23885d2e.png";